export default (ms) => new Promise((res) => setTimeout(res, ms));
export const delayTime = 2000;
